// X-17: a one-time message that survives a sign-out redirect (e.g. "Your
// account has been deleted.") and is shown once by the login page.
// sessionStorage can throw (private mode, blocked storage): then there is
// simply no flash.
const KEY = 'hh.flash';

export function setFlash(message) {
  try { if (message) window.sessionStorage.setItem(KEY, String(message)); } catch (e) { /* no storage */ }
}

// Returns the message once and clears it.
export function takeFlash() {
  try {
    const m = window.sessionStorage.getItem(KEY);
    if (m != null) window.sessionStorage.removeItem(KEY);
    return m || '';
  } catch (e) { return ''; }
}
